module.exports = __webpack_public_path__ + "static/media/albume-icon.e12a1170.svg";